import React, { FC } from 'react';
import { useStyles } from './EvIoMatchTypeFormat.styles';
import { EvIoGameSetupSettings, Identifier } from '@okletsplay/core';
import { getEvIoMatchSetupSettingsOptions } from 'modules/tournaments/hooks/get-ev-io-match-setup-settings-options';
import { Grid } from '@mui/material';
import { DefaultDisplayValue } from 'app/enums';
import { useSelector } from 'react-redux';
import { gamesSelectorFactory } from 'modules/games/store/games/selectors';
import { GameActivityType } from 'shared/enums';

export enum EvIoMatchTypeFormatVariant {
  Large = 'large',
  OneLine = 'one-line',
}

interface ComponentProps {
  variant?: EvIoMatchTypeFormatVariant;
  settings: EvIoGameSetupSettings;
  gameId: Identifier;
}

export const EvIoMatchTypeFormat: FC<ComponentProps> = ({
  variant = EvIoMatchTypeFormatVariant.Large,
  settings,
  gameId,
}) => {
  const { classes } = useStyles();

  const game = useSelector(gamesSelectorFactory.useById(gameId));

  if (!game) {
    return null;
  }

  const options = getEvIoMatchSetupSettingsOptions(settings, game, GameActivityType.Match);

  const findValue = (label: string) =>
    options.find((option) => option.label === label)?.value ?? DefaultDisplayValue.NA;

  if (variant === EvIoMatchTypeFormatVariant.Large) {
    const midIndex = Math.ceil(options.length / 2);
    const optionsInParts = [options.slice(0, midIndex), options.slice(midIndex)];

    return (
      <Grid container columnSpacing={3}>
        {optionsInParts.map((optionsPart, partIndex) => (
          <Grid item key={partIndex}>
            <ul className={classes.list}>
              {optionsPart.map((option, optionIndex) => (
                <li key={partIndex + optionIndex}>
                  {option.label}: {option.value}
                </li>
              ))}
            </ul>
          </Grid>
        ))}
      </Grid>
    );
  }

  return (
    <>
      {findValue('Game Mode')} | 1v1 | {findValue('Game Duration')}
    </>
  );
};
